import * as Yup from 'yup';
import {
  CardContent,
  CardHeader,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  ListItemIcon,
  IconButton,
  Tooltip,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { RedesignChart } from '../../chart/RedesignChart';
import { useSelector } from 'react-redux';
import UserScreensInternetRanking from '../components/UserScreensInternetRanking';
import { getNiceTimestamp } from 'src/utils/get-nice-timestamp';
import DraftsIcon from '@mui/icons-material/Drafts';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNavigate } from 'react-router-dom';
import MailIcon from '@mui/icons-material/Mail';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import RedesignPlayer from 'src/views/screen/components/RedesignPlayer';

//Widget content - required
export const WidgetContent = ({ widgetData, editMode }) => {
  const { t } = useTranslation();
  const { screens } = useSelector((state) => state.Screen);

  const [screenIndex, setScreenIndex] = useState(0);
  const [currentScreenGroup, setCurrentScreenGroup] = useState(0)

  const groups = []

  for (let x = 1; x <= screens.length; x++) {
    groups.push(x)
  }

  return (
    <CardContent
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '30px',
      }}
    >
      {screens.length > 0 ? (
        <>
          {screens[currentScreenGroup]?.playlist && (
            <RedesignPlayer
              portable
              playlist={screens[currentScreenGroup]?.playlist}
              open={true}
            />
          )}
          {/* {screens[currentScreenGroup+1]?.playlist && (
            <RedesignPlayer
              portable
              playlist={screens[currentScreenGroup+1]?.playlist}
              open={true}
            />
          )} */}
          {!screens[0]?.playlist && (
            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <Typography variant='subtitle1'>
                {t('components.widgetStudio.errorLoadingContent')}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              overflowX: 'scroll',
              width: '100%',
              '&::-webkit-scrollbar': {
                width: '5px',
              },
              '&::-webkit-scrollbar-track': {
                // borderBottom: "1px solid #333333"
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#0E1320',
              },
            }}
          >
            <Box sx={{
                display: "flex",
                alignItems: "center"
            }}>
                {groups.map((item, index) => {
                return (
                    <Tooltip title={screens[index]?.deviceName}>
                        <Button
                        sx={{
                            mx: 3,
                            my: 2,
                            minWidth: "50px"
                        }}
                        key={index}
                        variant={index == currentScreenGroup ? 'contained' : 'text'}
                        onClick={() => setCurrentScreenGroup(index)}
                        >
                        {item}
                        </Button>
                    </Tooltip>
                );
                })}         
            </Box>
          </Box>
          {/* <IconButton onClick={() => screenIndex > 0 && setScreenIndex(screenIndex-1)}>
                <ArrowLeftIcon />
            </IconButton>
            <Tooltip title={screens[screenIndex]?.deviceName.length > 20 && screens[screenIndex]?.deviceName} >
                <Typography>
                    {screens[screenIndex]?.deviceName.length > 20 ? `${screens[screenIndex]?.deviceName.slice(0, 20)}...` : screens[screenIndex]?.deviceName}
                </Typography>
            </Tooltip>
            <IconButton onClick={() => screenIndex < screens.length-1 && setScreenIndex(screenIndex+1)}>
                <ArrowRightIcon />
            </IconButton>       */}
        </>
      ) : (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          <Typography variant='subtitle1'>
            {t('components.widgetStudio.noScreen')}
          </Typography>
          <Typography variant='caption'>
            {t('components.widgetStudio.studioPlaceholder')}
          </Typography>
        </Box>
      )}
    </CardContent>
  );
};

//Widget header - not required
export const WidgetHeader = ({ widgetData, actions, editMode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
//   return <></>;
    return (
      <CardHeader
        // title={(
        //   <Box sx={{
        //       display: "flex",
        //       alignItems: "center",
        //       gap: "20px"
        //   }}>
        //   {t('components.widgetNotifications.yourNotifications')}
        //       <IconButton onClick={() => navigate('/notifications')}>
        //           <NotificationsIcon color="primary" />
        //       </IconButton>
        //   </Box>
        // )}
        action={actions}
      />
    );
};

//Widget settings
export const type = 'studio';
export const displayName = 'Studio';
export const configOptions = {};
